import { AppData, Colors, Img, Lightning, Log, Utils } from "@lightningjs/sdk";
// @ts-ignore
import { InputField, Key as BaseKey, Keyboard } from "@lightningjs/ui";
import { AppSetup } from "../lib/app-setup";
import { Theme } from "./info-ui";
import { Helper } from "../lib/helper";
import { Logger } from "../lib/logger";

export interface KeyboardAdvancedTemplateSpec
  extends Lightning.Component.TemplateSpec {
  InputFieldWrapper: any;
  Keyboard: Keyboard;
}

export interface KeyboardAdvancedTypeConfig
  extends Lightning.Component.TypeConfig {
  IsPage: true;
}

export default class KeyboardAdvanced
  extends Lightning.Component<
    KeyboardAdvancedTemplateSpec,
    KeyboardAdvancedTypeConfig
  >
  implements Lightning.Component<KeyboardAdvancedTemplateSpec>
{
  InputFieldWrapper = this.getByRef("InputFieldWrapper")!;
  _item: any;
  static override _template(): Lightning.Component.Template<KeyboardAdvancedTemplateSpec> {
    return {
      ...super._template(),
      InputFieldWrapper: {
        rect: true,
        clipping: true,
        InputField: {
          type: InputField,
          inputText: {
            textColor: Colors("white").get(),
            fontSize: 35,
            paddingLeft: 30,
          },
          description: 'Enter Search Query'
        }
      },
      Keyboard: {
        type: Keyboard,
        collision:true,
        config: keyboardConfig(),
        currentLayout: "abc",
        //maxCharacters: 24,
        //signals: { onSearch: true, onInputChanged: true, onSpace:true,onCustom:true,onCustomI:true},
      },
    };
  }
  override _init() {
    if (uiConfig) {
      if (uiConfig.inputFieldWrapper) {
        this.tag("InputFieldWrapper").x = uiConfig.inputFieldWrapper.x;
        this.tag("InputFieldWrapper").y = uiConfig.inputFieldWrapper.y;
        this.tag("InputFieldWrapper").w = uiConfig.inputFieldWrapper.w;
        this.tag("InputFieldWrapper").h = uiConfig.inputFieldWrapper.h;
        this.tag("InputFieldWrapper").color = uiConfig.inputFieldWrapper.color;
      }

      if (uiConfig.inputField) {
        this.tag("InputField").x = uiConfig.inputField.x;
        this.tag("InputField").y = uiConfig.inputField.y;
        this.tag("InputField").maxLabelWidth = uiConfig.inputField.maxLabelWidth;
        this.tag("InputField").labelPositionStatic = false;
        if (uiConfig.inputField.inputFieldTextColor) {
          this.tag("InputField").patch({
            inputText: {
              textColor: uiConfig.inputField.inputFieldTextColor,
            },
          });
        }
      }
      if (uiConfig.keyboard) {
        this.tag("Keyboard").x = uiConfig.keyboard.x;
        this.tag("Keyboard").y = uiConfig.keyboard.y;
        this.tag("Keyboard").w = uiConfig.keyboard.w;
        this.tag("Keyboard").h = uiConfig.keyboard.h;
        try {
          if (uiConfig.keyboard.maxCharacters) {
            this.tag("Keyboard").maxCharacters =
              uiConfig.keyboard.maxCharacters;
          }
        } catch (e) {}
      }
    }
    const { appConfig } = AppData as AppSetup;
    setTimeout(() => {
      //if (uiConfig && uiConfig.keyboard && uiConfig.keyboard.defaultValue) {
        this.tag("Keyboard").add(appConfig?.searchInput);
        this.tag("Keyboard").signals = { onSearch: true, onInputChanged: true, onSpace:true,onCustom:true,onCustomI:true,onExit: true}
      //}
    }, 100);
  }

  override _setup() {
    const inputField = this.tag("InputField");
    this.tag("Keyboard").inputField(inputField);
  }

  override set params(args:any){
    this.args = args;
  }
  onInputChanged(event: any) {
    const inputStr = Helper.trimSearchString(event.input)

    if(inputStr.length >=2 ||  inputStr.length==0) {
        this.signal("onInputChanged", event);
    }

  }

  onSpace(event: any) {
    if(event.input === ' '){
      this.tag('Keyboard').remove();
    }
    if(event.input && event.input.indexOf('  ')>-1){
      this.tag('Keyboard').remove();
    }
  }

  onCustom(event: any) {
   Log.info("onCustom ", event.input);
    this.tag('Keyboard').remove();
  }

  onExit(event: any){
    this.fireAncestors('$onCancel', event )
  }

  onCustomI(event: any) {
   Log.info("onCustomI ", event.input);
    this.tag('Keyboard').add('i');
  }

  onSearch(event: any) {
   Log.info("search", event.input);
  }

  override _active() {
    super._active();
    //this.tag("InputFieldWrapper").color = Colors("#777777").get();
  }
  override _getFocused() {
    return this.tag("Keyboard");
  }

  override _firstActive() {    
  }

  override _focus() {}

  override _unfocus() {}

  $KeyHover(target) {
   // console.log('KeyboardAdvanced _handleHover: ', target._data.key)
    this.tag('Keyboard').focus(target._data.key)
    this.tag('Keyboard')._refocus()
    this.fireAncestors('$setStateHover', 'KeyboardPanel')
  }

  $KeyClick(target) {
   // console.log('KeyboardAdvanced _handleClick: ', target._data.key)
    if(target._data.key == 'Clear') {
      this.tag('Keyboard').clear()
    } else if(target._data.key == 'Space') {
      this.tag('Keyboard').add(' ')
    } else if(target._data.key == 'Custom') {
      this.tag('Keyboard').remove()
    } else {
      this.tag('Keyboard').add(target._data.key)
    }
  }
}

class Key extends BaseKey {
  _theme: Theme = {};

  static _template() {
    return {
      ...super._template(),
      collision:true
    }
  }

  _init() {
    this.parent.collision = true
    this.parent.parent.collision = true
    this.parent.parent.parent.collision = true
  }

  _handleHover(target) {
    this.fireAncestors('$KeyHover', target)
    return false
  }

  _handleClick(target) {
    this.fireAncestors('$KeyClick', target )
  }

  _firstActive() {
    this.label = {
      mountY: 0.45,
    };
    this.labelColors = {
      unfocused: uiConfig.keyboard.keyLabelColor,
    };
    this.backgroundColors = {
      unfocused: uiConfig.keyboard.keyBGColor,
      focused: uiConfig.keyboard.keyBGColorFocus,
    };
    if (this.hasFocus()) {
      this._focus();
    }
  }

  static get width() {
    return uiConfig.keyboard.keyWidth;
  }
  static get height() {
    return uiConfig.keyboard.keyHeight;
  }

  _focus() {
    const { appState , platform } = AppData as AppSetup
    const app = appState?.getApp();
    this._theme = (app?.themesObj as Theme) || {};
    const appApiConfig = appState?.getAppApiConfig();
    this._theme.gridfocuscolor= `0xff${appApiConfig?.appLayoutConfig?.gridfocuscolor}` || '0xffffffff';
    let {focused, unfocused = 0xff000000} = this.backgroundColors;
    let {focused: labelFocused, unfocused: labelUnfocused = 0xffffffff} = this.labelColors;
    const focusColor = this._theme.gridfocuscolor || focused
    this.patch({
      Background: {smooth: {color: focusColor || unfocused}},
      Label: {smooth: {color: labelFocused || labelUnfocused}},
      shader: { type: Lightning.shaders.RoundedRectangle, radius: 12 },
    });
    if(!this.label?.texture?.text) {
      platform?.textToSpeach(this.tts)
    } else {
      platform?.textToSpeach(this.label?.texture?.text)
    }
    
  }

  _unfocus() {
    let {unfocused = 0xff000000} = this.backgroundColors;
    let {unfocused: labelUnfocused = 0xffffffff} = this.labelColors;

    this.patch({
        Background: {smooth: {color: unfocused}},
        Label: {smooth: {color: labelUnfocused}},
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 0 },
    });
  }
}

class KeyOld extends BaseKey {
  _firstActive() {
    this.label = {
      mountY: 0.45,
    };
    this.labelColors = {
      unfocused: uiConfig.keyboard.keyLabelColor,
    };
    this.backgroundColors = {
      unfocused: uiConfig.keyboard.keyBGColor,
      focused: uiConfig.keyboard.keyBGColorFocus,
    };
    if (this.hasFocus()) {
      this._focus();
    }
  }

  static get width() {
    return uiConfig.keyboard.keyWidth;
  }
  static get height() {
    return uiConfig.keyboard.keyHeight;
  }
}

class ActionKey extends Key {
  _active() {
    this.label = {
      mountY: 0.45,
    };
    this.labelColors = {
      focused: uiConfig.keyboard.keyLabelColor,
    };
    this.backgroundColors = {
      unfocused: uiConfig.keyboard.keyBGColor,
      focused: uiConfig.keyboard.keyBGColorFocus,
    };
    if (this.hasFocus()) {
      this._focus();
    }
  }

  static get height() {
    return uiConfig.keyboard.actionKeyHeight;
  }

  static get width() {
    return uiConfig.keyboard.actionKeyWidth;
  }

}

class IconKey extends ActionKey {
  set icon(src) {
    this._icon = src;
    //call for _update
    this._update();
  }

  get icon() {
    return this._icon;
  }

  _update() {
    if (!this.active) {
      //blocking update if not active.
      return;
    }
    const hasFocus = this.hasFocus();
    let { focused, unfocused = 0xff000000 } = this.backgroundColors;
    //Use labelColors and label to color the icon.
    let { focused: labelFocused, unfocused: labelUnfocused = 0xffffffff } =
      this.labelColors;
    this.patch({
      Background: {
        color: hasFocus && focused ? focused : unfocused,
        //w: (w: any) => (hasFocus && focused ? w + 50 : w),
        //h: (h: any) => (hasFocus && focused ? h + 50 : h),
      },
      Label: {
        src: Utils.asset(this.icon),
        color: hasFocus && labelFocused ? labelFocused : labelUnfocused,
      },
    });
  }
}

const uiConfig = {
  inputFieldWrapper: {
    x: 100,
    y: 50,
    h: 90,
    w: 490,
    color: Colors("#38385e").get(),
  },
  inputField: {
    x: 100,
    y: 20,
    maxLabelWidth: 460,
    inputFieldTextColor: Colors("white").get(),
  },
  keyboard: {
    x: 100,
    y: 150,
    w: 600,
    h: 600,
    maxCharacters: 18,
    //defaultValue: 'the',
    keyLabelColor: Colors("white").get(),
    //keyBGColor: Colors("#777777").darker(0.1).get(),
    keyBGColor: Colors("#38385e").get(),
    //keyBGColorFocus: Colors("#C22843").get(),
    keyBGColorFocus: Colors("#ff0000").get(),
    keyWidth: 80,
    keyHeight: 80,
    actionKeyWidth: 160,
    actionKeyHeight: 80,
  },
};

const keyboardConfig = ()=> {
  let newKeyboardConfig = {
  layouts: {
    abc: [
      ["a", "b", "c", "d", "e", "f"],
      ["g", "h", "i", "j", "k", "l"],
      ["m", "n", "o", "p", "q", "r"],
      ["s", "t", "u", "v", "w", "x"],
      ["y", "z", "1", "2", "3", "4"],
      ["5", "6", "7", "8", "9", "0"],
      ["Clear", "Space", "Custom"],
    ],
  },
  styling: {
    align: "center",
    horizontalSpacing: 2,
    verticalSpacing: 2,
  },
  buttonTypes: {
    default: {
      type: Key,
      //radius:20,
    },
    CustomI:{
      type: Key,
    },
    Custom: {
      type: IconKey,
      w: 162,
      icon: "images/backspace.png",
      tts: 'backspace'
    },
    Exit: {
      type: IconKey,//ActionKey,
      label: "Exit",
      w: 162,
      icon: "images/cancel.png",
      tts: 'Exit'
    },
    Layout: {
      type: ActionKey,
      //radius:20,
    },
    Space: {
      type: IconKey,//ActionKey,
      w: 163,
      //label: "space",
      icon: "images/space-bar.png",
      tts: 'space'
    },
    Clear: {
      type: IconKey,//ActionKey,
      label: "clear",
      w: 162,
      icon: "images/delete.png",
      tts: 'clear'
    },
    Search: {
      type: ActionKey
    },
  },
 }
 const { appConfig } = AppData as AppSetup

 if(appConfig?.enableContextualBackspace) {
  const newArr = ["Exit","Clear", "Space", "Custom"]
  newKeyboardConfig.layouts.abc[6] = newArr,
  newArr.map(val=>{
    newKeyboardConfig.buttonTypes[val].w = 121
  })
 }
 return newKeyboardConfig
};
